import { Reveal, SectionHead } from "@/components/Reveal";

const CREDENTIALS = [
  "Product management & program management",
  "Agile, facilitation & leadership",
  "Process improvement & AI/product innovation",
  "Fluent in French and English",
];

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="scroll-mt-20 border-t border-line bg-parch py-20 sm:py-28 lg:py-32"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-14 lg:grid-cols-12 lg:gap-16">
          <div className="lg:col-span-7">
            <SectionHead
              chapter="06 — About"
              title="Strategy grounded in product management."
              testid="about-head"
            />
            <Reveal delay={0.2}>
              <div data-testid="about-founder-bio" className="mt-8 space-y-5 text-base leading-relaxed text-body sm:text-lg">
                <p>
                  Kristel Procida is a strategy and product management
                  professional with 10+ years of experience leading products,
                  programs and cross-functional initiatives across corporate,
                  entrepreneurial, nonprofit and community-focused environments.
                </p>
                <p>
                  She has led cross-functional teams, facilitated strategic and
                  collaborative workshops, coached teams and entrepreneurs, and
                  worked with organizations navigating complex problems and
                  change.
                </p>
                <p className="text-ink">
                  She is the founder of KP Strategy — where product thinking,
                  systems thinking and practical execution come together to
                  help organizations build better products, programs and ways
                  of working.
                </p>
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-5">
            <Reveal delay={0.25}>
              <div className="border border-line bg-paper">
                <div className="border-b border-line bg-parch px-8 py-8 sm:px-10">
                  <img
                    data-testid="about-founder-headshot"
                    src="/assets/founder-headshot.png"
                    alt="Kristel Procida, founder of KP Strategy"
                    className="mx-auto aspect-[5/4] w-full max-w-[270px] object-cover object-[center_18%]"
                    loading="lazy"
                  />
                </div>
                <p className="border-b border-line px-6 py-4">
                  <span className="font-serif text-lg text-ink">Kristel Procida</span>
                  <span className="ml-3 font-mono text-[11px] uppercase tracking-[0.25em] text-faint">
                    Founder, KP Strategy
                  </span>
                </p>
                <ul className="divide-y divide-line">
                  {CREDENTIALS.map((c) => (
                    <li
                      key={c}
                      className="flex items-center gap-3 px-6 py-4 text-sm text-body"
                    >
                      <span className="text-amber" aria-hidden="true">✦</span>
                      {c}
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
